import {
	OPERAND_TYPE_LIST,
	OPERAND_TYPE_VALUE,
	OPERAND_TYPE_KEYWORD,
	type Operand,
} from '@atlaskit/jql-ast';

export const getOperandValues = (operand?: Operand): string[] => {
	if (!operand) {
		return [];
	}

	if (operand.operandType === OPERAND_TYPE_LIST) {
		const values: string[] = [];

		for (let i = 0; i < operand.values.length; i++) {
			values.push(...getOperandValues(operand.values[i]));
		}

		return values;
	}

	if (operand.operandType === OPERAND_TYPE_VALUE) {
		return [operand.text];
	}

	if (operand.operandType === OPERAND_TYPE_KEYWORD) {
		return [operand.value];
	}

	return [operand.function.value];
};
